import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';
import openUserStories from '../openUserStories';
import store from '../storyStore';

/**
 * Small badge in a post header marking that its author has an active story.
 *
 * Posts already carry a lot of signal around the avatar — a group-coloured
 * border and a badge attached underneath — so a third ring there would be
 * unreadable. The badge moves that signal to the free space on the right of
 * the header instead, leaving the avatar untouched.
 *
 * Props:
 *   user – the post's author
 */
export default class StoryBadge extends Component {
  view() {
    const user = this.attrs.user;

    // Dimmed once watched, like the rings, rather than hidden: removing it
    // would leave no way back to the story, and would look the same as the
    // story having expired.
    const seen = store.isSeen(user.id());
    const followers = store.isFollowerOnly(user.id());

    return (
      <button
        className={
          'StoryBadge' +
          (seen ? ' StoryBadge--seen' : '') +
          (followers ? ' StoryBadge--followers' : '')
        }
        type="button"
        title={app.translator.trans('happydigital-stories.forum.view_story')}
        onclick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          openUserStories(user);
        }}
      >
        {icon('fas fa-circle-notch', { className: 'StoryBadge-icon' })}
        <span className="StoryBadge-label">
          {app.translator.trans('happydigital-stories.forum.story_badge')}
        </span>
      </button>
    );
  }
}
